import { Button, ScrollArea, Stack } from '@mantine/core';

import { useCallback, useState } from 'react';

import { useParams } from 'react-router-dom';

import Dropzone from '../../../components/Dropzone';
import { type FileWithMetadata } from '../../../components/Forms/UploadResources/UploadResources';
import useEnsisMutation from '../../../hooks/useEnsisMutation';
import { withAnalyticsEvent } from '../../../utils/analyticsUtils';
import { handleFileUploadError } from '../../../utils/apiUtils';

const OpportunityEvaluator: React.FC = () => {
  const [files, setFiles] = useState<FileWithMetadata[]>([]);
  const { organization } = useParams();
  const evaluateOpportunityMutation = useEnsisMutation('/app/opportunity-assessments', {
    contentType: 'multipart/form-data',
    requestType: 'post',
    queryKeysToInvalidate: ['/app/opportunity-assessments'],
    showSuccessMessage: false,
    showFailureMessage: false,
    onError: handleFileUploadError
  });
  const handleEvaluateOpportunity = useCallback(() => {
    evaluateOpportunityMutation.mutate({
      name: files[0].fileObject.name,
      organization_slug: organization ?? '',
      files: files.map((file) => file.fileObject) as unknown as string[]
    }, {
      onSuccess: () => {
        setFiles([]);
      }
    });
  }, [evaluateOpportunityMutation, files, organization]);

  return (
    <Stack gap={8} h='100%' align='center'>
      <ScrollArea h='100%' pr={16} w='100%'>
        <Dropzone instructionText='Click to upload, or drag and drop' files={files} setFiles={setFiles} />
      </ScrollArea>
      <Button
        w={100}
        loading={evaluateOpportunityMutation.isPending}
        disabled={files.length === 0 || evaluateOpportunityMutation.isPending}
        onClick={withAnalyticsEvent(handleEvaluateOpportunity, 'EvaluateOpportunity')}
      >
        Evaluate
      </Button>
    </Stack>
  );
};

export default OpportunityEvaluator;
